var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-info" }, [
    _c("div", { staticClass: "alpheios-info__faq" }, [
      _c("a", { attrs: { href: _vm.faqLink, target: "_blank" } }, [
        _c("button", { staticClass: "alpheios-button-tertiary" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.l10n.getMsg("LABEL_INFO_FAQ")) +
              "\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "alpheios-info__helptext" }, [
      _c("div", { staticClass: "alpheios-notification-area__close-btn" }),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_GETTINGSTARTED")))]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.$store.state.app.embedLibActive,
              expression: "! $store.state.app.embedLibActive",
            },
          ],
          staticClass: "alpheios-info__helpitem alpheios-info__helpitem__logo",
        },
        [
          _c(
            "span",
            { staticClass: "alpheios-info__helpicon" },
            [_c("logo-icon")],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "alpheios-text__small" }, [
            _vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_ACTIVATE"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "alpheios-info__helpitem" }, [
        _c(
          "span",
          { staticClass: "alpheios-info__helpicon" },
          [_c("tap-gesture-icon")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "alpheios-text__small" }, [
          _vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_CLICK"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alpheios-info__helpitem" }, [
        _c(
          "span",
          { staticClass: "alpheios-info__helpicon" },
          [_c("lookup-icon")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "alpheios-text__small" }, [
          _vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_LOOKUP"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alpheios-info__helpitem" }, [
        _c(
          "span",
          { staticClass: "alpheios-info__helpicon" },
          [_c("reading-tools-icon")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "alpheios-text__small" }, [
          _vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_TOOLBAR"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alpheios-info__helpitem" }, [
        _c(
          "span",
          { staticClass: "alpheios-info__helpicon" },
          [_c("swap-position")],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "alpheios-text__small" }, [
          _vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_ARROW"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.l10n.getMsg("TEXT_INFO_TIPS")))]),
    _vm._v(" "),
    _c("p", {
      staticClass: "alpheios-text-small",
      domProps: {
        innerHTML: _vm._s(
          _vm.l10n.getMsg("TEXT_INFO_LANGDETECT", {
            languageName: _vm.defaultLanguage,
          })
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }